"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwaptionType = exports.OptionSettlementType = exports.PremiumSettlementType = exports.ScheduleType = exports.Outputs = exports.ExerciseStyle = exports.CallPut = exports.BuySell = exports.PriceSide = void 0;
var cap_floor_1 = require("./cap-floor");
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return cap_floor_1.PriceSide; } });
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "BuySell", { enumerable: true, get: function () { return financial_contracts_1.BuySell; } });
Object.defineProperty(exports, "CallPut", { enumerable: true, get: function () { return financial_contracts_1.CallPut; } });
Object.defineProperty(exports, "ExerciseStyle", { enumerable: true, get: function () { return financial_contracts_1.ExerciseStyle; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
var ScheduleType;
(function (ScheduleType) {
    ScheduleType["FixedLeg"] = "FixedLeg";
    ScheduleType["FloatLeg"] = "FloatLeg";
    ScheduleType["UserDefined"] = "UserDefined ";
})(ScheduleType || (exports.ScheduleType = ScheduleType = {}));
var PremiumSettlementType;
(function (PremiumSettlementType) {
    PremiumSettlementType["Spot"] = "Spot";
    PremiumSettlementType["Forward"] = "Forward";
    PremiumSettlementType["Schedule"] = "Schedule ";
})(PremiumSettlementType || (exports.PremiumSettlementType = PremiumSettlementType = {}));
var OptionSettlementType;
(function (OptionSettlementType) {
    OptionSettlementType["Cash"] = "Cash";
    OptionSettlementType["Physical"] = "Physical";
    OptionSettlementType["CCP"] = "CCP";
})(OptionSettlementType || (exports.OptionSettlementType = OptionSettlementType = {}));
var SwaptionType;
(function (SwaptionType) {
    SwaptionType["Payer"] = "Payer";
    SwaptionType["Receiver"] = "Receiver";
})(SwaptionType || (exports.SwaptionType = SwaptionType = {}));
